import { DownOutlined, GlobalOutlined } from '@ant-design/icons';
import { Avatar, Collapse, CollapseProps } from 'antd';

import { ShippingProfileCarrierServiceDTO } from '@invenco/sales-interface/interfaces';
import { CarrierDTO } from '@invenco/shipping-interface';

import { HorizontallySpaced } from '../../../../../styles/layout';
import { CarrierCollapse, CarrierServiceLine } from '../carrier-list/styles';
import { useStaticCarrierListComponent } from './useStaticCarrierListComponent';

type Props = {
  carrierService: ShippingProfileCarrierServiceDTO;
  carriersById?: Record<string, CarrierDTO>;
};

export const renderCollapseIcon: CollapseProps['expandIcon'] = ({ isActive }) => (
  <DownOutlined rotate={isActive ? 180 : 0} aria-hidden="true" />
);

export function StaticCarrierList({ carrierService, carriersById }: Props) {
  const { models } = useStaticCarrierListComponent({
    carrierService,
    carriersById,
  });
  if (models.isLoadingCarrierService) {
    return <div>Loading...</div>;
  }
  if (!models.carrierService) {
    return <div>No carrier service found</div>;
  }
  if (!models.carrier) {
    return <div>No carrier found for service {models.carrierService.name}</div>;
  }
  return (
    <div>
      <CarrierCollapse bordered={false} expandIconPosition="end" expandIcon={renderCollapseIcon}>
        <Collapse.Panel
          key={models.carrierService.carrierId}
          header={
            <HorizontallySpaced aria-label={models.carrier.name}>
              <Avatar shape="square" icon={<GlobalOutlined aria-hidden="true" />} />
              <span>{models.carrier.name}</span>
            </HorizontallySpaced>
          }
        >
          <CarrierServiceLine key={models.carrierService.id}>
            {models.carrierService.name}
          </CarrierServiceLine>
        </Collapse.Panel>
      </CarrierCollapse>
    </div>
  );
}
